import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=b95e898c"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports